import { Component, Match, Show, Switch, createSignal } from 'solid-js'
import Button from '/web/shared/Button'
import { TitleCard } from '/web/shared/Card'
import { i18nStore } from '../../store'

const OpenRouterOauth: Component<{
  onKey: (key: string) => void
  deleteKey: () => void
  keySet: boolean
}> = (props) => {
  const i18n = i18nStore((s) => s)
  const [trying, setTrying] = createSignal(false)

  const handleCode = async (code: string) => {
    setTrying(true)
    const res = await fetch(`https://openrouter.ai/api/v1/auth/keys`, {
      method: 'POST',
      body: JSON.stringify({ code }),
    }).then((res) => res.json())

    props.onKey(res.key)
    setTrying(false)
  }

  const start = () => {
    setTrying(true)
    const url = location.origin
    const child = window.open(
      `https://openrouter.ai/auth?callback_url=${url}`,
      '_blank',
      'width=600,height=800,scrollbar=yes,top=100,left=100'
    )!

    const interval = setInterval(() => {
      try {
        if (child.closed) {
          setTrying(false)
          clearInterval(interval)
        }

        const query = child.location.search
        const [, code] = query.split('=')
        if (!code) return

        handleCode(code)
        child.close()
        clearInterval(interval)
      } catch (ex) {}
    }, 500)
  }

  return (
    <>
      <Show when={!props.keySet}>
        <TitleCard>
          <div innerHTML={i18n.t.openrouter_oauth_instruction} />
        </TitleCard>
      </Show>

      <div>
        <Switch>
          <Match when={trying()}>
            <Button disabled>{i18n.t.openrouter_oauth_logging_in}</Button>
          </Match>
          <Match when={!props.keySet}>
            <Button onClick={start}>{i18n.t.openrouter_oauth_login}</Button>
          </Match>

          <Match when={props.keySet}>
            <Button onClick={props.deleteKey}>{i18n.t.openrouter_oauth_logout}</Button>
          </Match>
        </Switch>
      </div>
    </>
  )
}

export default OpenRouterOauth
